<template>
  <input type="tel" v-model="viewValue" @input="e => viewValue = e.target.value" :disabled="disabled" :class="ClassName?'form-control '+ClassName:'form-control'" :placeholder="placeholder?placeholder:''">
  <input :name="name" :value="realValue" type="hidden" />
</template>

<script>
export default {
  name: "NumberInput",
  data: () =>
  {
    return {
      realValue:'',
      viewValue:''
    }
  },
  mounted()
  {
    this.viewValue = this.money(this.value?this.value:'');
    this.render();
  },
  methods:{
    render()
    {
      if (!this.viewValue)
      {
        this.realValue = '';
        // v = Number(v).toString();
        this.viewValue = '';
        this.$emit('input','');
        this.$emit('change','');
        return;
      }
      let v='';
      let dotFlag = false;
      for (let i=0;i<this.viewValue.length;i++)
      {
        if (!isNaN(this.viewValue[i]))
          v+=this.viewValue[i];
        else if(!dotFlag && this.viewValue[i]==='.')
        {
          v+='.';
          dotFlag = true
        }
      }
      // v = Number(v).toString();
      this.realValue = v;
      this.viewValue = this.money(v);
      this.$emit('input',v);
      this.$emit('change',v);
    },
    replaceAll(str, find, replace)
    {
      return str.split(find).join(replace);
    },
    substr_replace(str, replace, start, length)
    {
      if (start < 0)
      {
        // start position in str
        start = start + str.length
      }
      length = length !== undefined ? length : str.length;
      if (length < 0)
      {
        length = length + str.length - start
      }

      return [
        str.slice(0, start),
        replace.substr(0, length),
        replace.slice(length),
        str.slice(start + length)
      ].join('')
    },
    money(number)
    {
      if (!number)
        return number;
      number = number.toString();
      let n=number.length;

      let k=1;
      for(let j=n-1;j>=0;j--)
      {
        if (number==='.')
        {
          k=1;
          continue;
        }
        if(k%3===0 && j!==0)
          number = this.substr_replace(number, ',', j, 0);
        k++;
      }
      return number;
    },
  },
  watch: {
    viewValue()
    {
      this.render();
    },
    value()
    {
      this.viewValue = this.money(this.value?this.value:'');
      this.render();
    },
  },
  props:['value','ClassName','disabled','name','placeholder']
}
</script>

<style scoped>

</style>
